@if (scalarText(); as text) {
  <span class="agent-tool-node__scalar">{{ text }}</span>
}

@if (object(); as object) {
  <div class="agent-tool-node__object">
    @for (field of object.fields; track field.key) {
      <div class="agent-tool-node__row">
        <div class="agent-tool-node__key">{{ field.label }}</div>
        <div class="agent-tool-node__value">
          <app-agent-tool-result-node [node]="field.node"></app-agent-tool-result-node>
        </div>
      </div>
    }
  </div>
  @if (object.hiddenFields) {
    <div class="agent-tool-node__note">{{ "agent.result.more-fields" | translate: { count: object.hiddenFields } }}</div>
  }
}

@if (table(); as table) {
  <table class="agent-tool-node__table">
    <thead>
      <tr>
        @for (column of table.columns; track column.key) {
          <th>{{ column.label }}</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (row of table.rows; track $index) {
        <tr>
          @for (column of table.columns; track column.key) {
            <td>{{ row[column.key] }}</td>
          }
        </tr>
      }
    </tbody>
  </table>
  @if (table.truncated) {
    <div class="agent-tool-node__note">
      {{ "agent.result.more-rows" | translate: { count: table.total - table.rows.length } }}
    </div>
  }
  @if (table.hiddenColumns) {
    <div class="agent-tool-node__note">
      {{ "agent.result.more-columns" | translate: { count: table.hiddenColumns } }}
    </div>
  }
}

@if (list(); as list) {
  <div class="agent-tool-node__list">
    @for (item of list.items; track $index) {
      <div class="agent-tool-node__list-item">
        <app-agent-tool-result-node [node]="item"></app-agent-tool-result-node>
      </div>
    }
    @if (list.truncated) {
      <div class="agent-tool-node__note">
        {{ "agent.result.more-rows" | translate: { count: list.total - list.items.length } }}
      </div>
    }
  </div>
}
